function getCartHtml(){
          $.ajax({
            url: '/cart',
            type: "GET",
            dataType: "html",
            success: function(data) {
              $('.cart_empty_wrap').html($(data).find('.cart_empty_wrap').html());
              $('.left_side_upper_wrap').html($(data).find('.left_side_upper_wrap').html());
              $('.cart_right_side_wrap').html($(data).find('.cart_right_side_wrap').html());
             $('.main_icon_header_wrap').html($(data).find('.main_icon_header_wrap').html());
              $('.account-icon-container').html($(data).find('.account-icon-container').html());
              

              $('.cart__footer').html($(data).find('.cart__footer').html());
              $('.cart-icon .cart-items').html($(data).find('.cart-icon .cart-items').html());
              $('.cart_icon_wrapping').html($(data).find('.cart_icon_wrapping').html());
              if(getCookie("ship_zip") != undefined && getCookie("ship_state") ){
             const cartDATA = JSON.parse($(data).find('#CartDataJSON').text());
              var zip=getCookie("ship_zip");
               getShippingRates(cartDATA,zip,getCookie("ship_state"),getCookie("ship_city"));
            }
            setTimeout(function() {
var check_length = $(".cart-items .cart-item.cart-item").length;
 if(check_length == 0){
          $('body').addClass('empty_cart');
          }else{
          $('body').removeClass('empty_cart');
     }
  }, 500);
    let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];
$("span.total_saved_items").html("("+savedProducts.length+")");
 if (savedProducts.length === 0) {
$(".saved_items").addClass('disabled');
 }
            },
          });
}
            setTimeout(function() {
$('.quantity-selector').on('input', function () {
  let val = parseInt($(this).val());

  if (isNaN(val) || val <= 0) {
    $(this).val(1);
  }
});
}, 2500);
        $(document).on("change",".quantity-selector",function() {
    const $input = $(this);
    const variantId = $input.data('id');
    const newQuantity = parseInt($input.val()) || 1;

    // Get base price from input's data attribute
    const basePrice = parseFloat($input.data('price')) || 0;

    // Calculate new total price
    const newTotal = (basePrice * newQuantity).toFixed(2);

    // Update the corresponding product price in the UI
    $input.closest('.saved-product-row').find('.product-price').text(`$${newTotal}`);

    // Update localStorage
    let storedData = JSON.parse(localStorage.getItem('savedProducts') || '[]');
    let found = false;

    for (let i = 0; i < storedData.length; i++) {
      if (storedData[i].variantId == variantId) {
        storedData[i].quantity = newQuantity;
        found = true;
        break;
      }
    }

    if (found) {
      localStorage.setItem('savedProducts', JSON.stringify(storedData));
    }
  });

$(document).ready(function () {

    var $scrollToTop = $(".scrollToTop");

    // Hide the button initially
    $scrollToTop.hide();

    $(window).scroll(function () {
        // Show button when scrolled 20% of the page
        if ($(window).scrollTop() > $(document).height() * 0.3) {
            $scrollToTop.fadeIn();
        } else {
            $scrollToTop.fadeOut();
        }
    });

    // Scroll to top on click
    $scrollToTop.click(function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
    });




// $(".more_grids_filters").hide();
// $(".learn_more_btn").show();
// $(".learn_less_btn").hide();


    if (window.location.href.indexOf('/cart#wishlist') !== -1) {
            var get_header_height = $(".menu_wrap_main").height();
        $('html, body').animate({
            scrollTop: $('#saved-for-later-section').offset().top - get_header_height - 20
        }, 500);
    }
    $(".accordion-header").on("click",function() {
        var body = $(this).next(".accordion-body");

        if (body.is(":visible")) {
            body.slideUp(500);
            $(this).find(".icon img").attr('src','https://cdn.shopify.com/s/files/1/0689/4980/3108/files/accordion-close.svg?v=1738581744');
        } else {
            $(".accordion-body").slideUp(500);
            $(".accordion-header .icon img").attr('src','https://cdn.shopify.com/s/files/1/0689/4980/3108/files/accordion-close.svg?v=1738581744');
            body.slideDown(500);
            $(this).find(".icon img").attr('src','https://cdn.shopify.com/s/files/1/0689/4980/3108/files/accordion-open.svg?v=1738581833');
        }
    });
  const renderSavedForLaterSection = () => {
    var savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];
    const $savedSection = $(".empty_text_save");
$("span.total_saved_items").html("("+savedProducts.length+ ")");
    if (savedProducts.length === 0) {
$(".saved_items").addClass('disabled');

      if ($savedSection.find(".saved-product-row").length === 0) {
        $savedSection.html("<p>Your wish list is currently empty.</p>");
      }
      $(".js-wishlist-button").hide();
      return;
    }else{
$(".saved_items").removeClass('disabled');

}

    // Show or hide the "Add All to Cart" button
    if (savedProducts.length > 1) {
      $(".js-wishlist-button").show();
    } else {
      $(".js-wishlist-button").hide();
    }

    savedProducts.forEach((savedProduct) => {
      const { handle, variantId, quantity } = savedProduct;

      // Check if product is already rendered
      const existingProduct = $savedSection.find(`[data-variant-id="${variantId}"]`);
      if (existingProduct.length > 0) {
        // Update existing product row
        existingProduct.find(".product-quantity input").val(quantity);
        return; // Skip fetching product data if it's already rendered
      }

      // Fetch product details
      $.getJSON(`/products/${handle}.js`, function (product) {
        const variant = product.variants.find((v) => v.id === variantId);
    const image = variant && variant.image ? variant.image : product.featured_image;
        const title = product.title;
        const url = product.url;
      var sku = variant ? variant.sku : product.sku;

if (sku && typeof sku === 'string') {
    if (sku.includes('AMZPWR')) {
        sku = sku.replace('AMZPWR', '');
    } else if (sku.includes('PWR')) {
        sku = sku.replace('PWR', '');
    }
}

        const weight = variant ? variant.weight / 1000 : product.variants[0].weight / 1000; // Assuming weight in grams
        const price = variant ? (variant.price / 100).toFixed(2) : (product.variants[0].price / 100).toFixed(2);
        const available = variant ? variant.available : product.variants[0].available;

        let productDetailsHTML = `<h4>${title}</h4>`;
        let productDetailsHTML2 = ``;

        if (sku) {
          productDetailsHTML2 += `<p><strong>SKU:</strong> ${sku}</p>`;
        }
        if (weight) {
          productDetailsHTML2 += `<p><strong>Weight:</strong> ${weight} kg</p>`;
        }

        let addToCartText = "Add to cart";
        if (!available) {
          addToCartText = "Sold out";
        }

        const $productRow = $(`
          <div class="saved-product-row" data-variant-id="${variantId}">
<div class="main_cart_item_wrap">
<div class="cart_image_wrap">
<a href="${url}">
   <div class="product-image">
            <img src="${image}" alt="${title}" class="product-image" />
</div>
</a>
</div>
<div class="cart_details_wrap">
            <div class="product-details"><a href="${url}">${productDetailsHTML}</a>${productDetailsHTML2}</div>
</div>
</div>
            <div class="product-quantity">
              <p>Saved Quantity: ${quantity}</p>
              <input data-price="${price}" aria-label="Change Quantity" data-id="${variantId}" data-handle="${handle}" class="quantity-selector form-control form-control-inline text-4 input-sm text-box single-line" data-val="true" data-val-min="Invalid quantity" data-val-min-val="0" data-val-number="The field Quantity must be a number." data-val-required="Invalid quantity" id="WishItems_0__Quantity" min="1" name="WishItems[0].Quantity" type="number" value="${quantity}" aria-invalid="false">
            </div>
              <div class="product-price">$${(price * quantity).toFixed(2)}</div>
      <div class="product-actions">
            <button class="add-to-cart-btn ${available}" data-variant-id="${variantId}">${addToCartText}</button>
            <button class="remove-saved-btn" data-handle="${handle}" data-variant-id="${variantId}"><i class="fa fa-times-circle-o"></i></button>
      </div>
          </div>
        `);

        // Append new product row
        $savedSection.append($productRow);

        // Attach event handlers for the new product row
        $productRow.find(".remove-saved-btn").on("click", function () {
const handleToRemove = $(this).data("handle");
          const variantIdToRemove = $(this).data("variant-id");
          let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];

    // Find the index of the item with matching variantId
    const indexToRemove = savedProducts.findIndex(item => String(item.variantId) === String(variantIdToRemove));

    if (indexToRemove !== -1) {
        savedProducts.splice(indexToRemove, 1); // Remove the item
        localStorage.setItem("savedProducts", JSON.stringify(savedProducts)); // Update local storage
    }
          $productRow.remove(); // Remove the product row from the DOM

          if (savedProducts.length === 0) {
            $savedSection.html("<p>Your wish list is currently empty.</p>");
            $(".js-wishlist-button").hide();
          }
        });
    $(document).on("click","button#pswish-move-all-to-cart",function() {
  jsonObj = [];

   $('.saved-product-row').each(function(){
      var total_ids= $(this).attr('data-variant-id');
      //alert(total_ids);
      var quanity = $(this).find('input.quantity-selector').val();

      item2 = {}
      item2 ["id"] = parseInt(total_ids);
      item2 ["quantity"] = quanity;
      jsonObj.push(item2);

    });
    $.ajax({
      type: "POST", 
      url: '/cart/add.js',
      data: {items: jsonObj },
      dataType: "json",
      success: function() {
    localStorage.removeItem("savedProducts");
$(".empty_text_save").html('<p>Your wish list is currently empty.</p>');
      $(".js-wishlist-button").hide();
getCartHtml();
      },
    });

    
});

        $productRow.find(".add-to-cart-btn").on("click", function () {
          const variantIdToAdd = $(this).data("variant-id");
        var get_q = $productRow.find('.quantity-selector').val();
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { id: variantIdToAdd, quantity: get_q },
            dataType: "json",
            success: function () {
              // const updatedProducts = savedProducts.filter(
              //   (product) => product.variantId !== variantIdToAdd
              // );
 let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];

    // Find the index of the item with matching variantId
    const indexToRemove = savedProducts.findIndex(item => String(item.variantId) === String(variantIdToAdd));

    if (indexToRemove !== -1) {
        savedProducts.splice(indexToRemove, 1); // Remove the item
        localStorage.setItem("savedProducts", JSON.stringify(savedProducts)); // Update local storage
    }
              $productRow.remove(); // Remove the product row from the DOM
            //  alert("Product added to cart!");

              if (savedProducts.length === 0) {
                $savedSection.html("<p>Your wish list is currently empty.</p>");
                $(".js-wishlist-button").hide();
              }
      getCartHtml();

            },
            error: function () {
             // alert("Failed to add product to cart.");
            },
          });
        });
      });
    });
  };

  // Initial render
  renderSavedForLaterSection();

  // Save for Later button click handler
    $(document).on("click",".save-for-later-btn",function(e) {
    e.preventDefault();
    e.stopPropagation();
var check_class = $(this).hasClass('main_product_save_button');
if(check_class == true){
const $button = $(this);
    const productHandle = $button.data("product-handle");
    var variantId = $button.attr("data-variant-id");
       variantId = parseInt(variantId);

    if($('body').hasClass('cart')){
   $button.fadeOut(200, function () {
      $button.text("Saving item").fadeIn(200);
$button.addClass('animation_start');
    });
      }else{
    $button.fadeOut(200, function () {
      $button.text("Saved").fadeIn(200);
$button.addClass('animation_start');
 
    });
    }
 
    setTimeout(function () {
      $button.text("Save for later").fadeIn(200);
$button.removeClass('animation_start');
 
    }, 2500);
 
    let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];
$("span.total_saved_items").html("("+savedProducts.length+")");
 
    const productIndex = savedProducts.findIndex(
      (item) => item.handle === productHandle && item.variantId === variantId
    );
 
    if (productIndex > -1) {
      savedProducts[productIndex].quantity += 1;
    } else {
      savedProducts.push({ handle: productHandle, variantId, quantity: 1 });
    }
 
    localStorage.setItem("savedProducts", JSON.stringify(savedProducts));
    renderSavedForLaterSection(); // Update section without clearing it

}else{
    const $button = $(this);
    const productHandle = $button.data("product-handle");
    const variantId = $button.data("variant-id");
    if($('body').hasClass('cart')){
   $button.fadeOut(200, function () {
      $button.text("Saving item").fadeIn(200);
$button.addClass('animation_start');
    });
      }else{
    $button.fadeOut(200, function () {
      $button.text("Saved").fadeIn(200);
$button.addClass('animation_start');

    });
    }
//$(this).parent().parent().find('.cross_button cart-remove-button').trigger('click');
var productid = $(this).attr('data-variant-id');
var get_quanitty = $(this).parents('.cart-item').find('input.quantity__input').val();
$.ajax({  
    type: 'POST',
    url: '/cart/change.js',
    data:{
      id: productid,
      quantity: 0
    },
    dataType: 'json',
    success: function(productid){
       getCartHtml();


    setTimeout(function () {
      $button.text("Save for later").fadeIn(200);
$button.removeClass('animation_start');

    }, 2500);

    let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];
$("span.total_saved_items").html(savedProducts.length);

    const productIndex = savedProducts.findIndex(
      (item) => item.handle === productHandle && item.variantId === variantId
    );

    if (productIndex > -1) {
      savedProducts[productIndex].quantity += 1;
    } else {
      savedProducts.push({ handle: productHandle, variantId, quantity: get_quanitty });
    }
$(".empty_text_save p").hide();
    localStorage.setItem("savedProducts", JSON.stringify(savedProducts));
    renderSavedForLaterSection(); // Update section without clearing it

    },
  });

}
  });
$(document).on("keypress", ".cart-item__quantity .quantity__input", function(event){
                if(event.which === 13){  // 13 is the Enter key
                    event.preventDefault();
    event.stopPropagation();
               var productid = $(this).parents('.cart-item').find(".save-for-later-btn").attr('data-variant-id');
var get_quanitty = $(this).val();
                  $(this).parents('.cart-item').find(".cart-item__totals .loading__spinner").removeClass("hidden");
                  var thisitem = $(this)
$.ajax({  
    type: 'POST',
    url: '/cart/change.js',
    data:{
      id: productid,
      quantity: get_quanitty
    },
    dataType: 'json',
    success: function(productid){
       getCartHtml();


    setTimeout(function () {
      $button.text("Save for later").fadeIn(200);
$button.removeClass('animation_start');

    }, 2500);

    let savedProducts = JSON.parse(localStorage.getItem("savedProducts")) || [];
$("span.total_saved_items").html(savedProducts.length);

    const productIndex = savedProducts.findIndex(
      (item) => item.handle === productHandle && item.variantId === variantId
    );

    if (productIndex > -1) {
      savedProducts[productIndex].quantity += 1;
    } else {
      savedProducts.push({ handle: productHandle, variantId, quantity: get_quanitty });
    }
$(".empty_text_save p").hide();
    localStorage.setItem("savedProducts", JSON.stringify(savedProducts));
    renderSavedForLaterSection(); // Update section without clearing it
$(thisitem).parents('.cart-item').find(".cart-item__totals .loading__spinner").addClass("hidden");
    },
  });
                }
            });

});
    $(document).on("click","#print-cart",function() {
    window.print();
  });
    $(document).on("click",".cross_button",function() {
    var $button = $(this);
 $button.fadeOut(200, function () {
      $button.text("Deleting").fadeIn(200);
    });
    
});
    $(document).on("click",".add_to_cart_inner .icon_save_for_later",function() {
        let $saveForLaterBtn = $(".save-for-later-btn");
        $saveForLaterBtn.fadeToggle(300);
    });
    $(document).on("click","button#toggle-btn",function() {
$(".content_1_wrap_dynmic").hide();
    $(".hidden-content").show();
});
    $(document).on("click",".read_more_categories",function() {
        $(this).hide();
      $("li.sub-entity-list-item.read_more_categories_grid").show();
    $("span.read_less_categories").show();
    });
    $(document).on("click",".read_less_categories",function() {
        $(this).hide();
      $(".read_more_categories_grid").hide();
    $(".read_more_categories").show();
    });
    $(document).on("click",".read_less_button",function() {
      $(this).hide();
        $(".read_more_button").show();
    $(".read_less_description").hide();
    $(".read_more_description").show();
  });
    $(document).on("click",".read_more_button",function() {
  $(this).hide();
        $(".read_less_button").show();
    $(".read_more_description").hide();
    $(".read_less_description").show();
  });
    $(document).on("click",".custom_chat_section a.btn.btn-primary.button--primarys",function(e) {
e.preventDefault();
e.stopPropagation();
 $('html, body').animate({
        scrollTop: $(".hbspt-form").offset().top - 300
    }, 500);
  });
 $(document).on("click",".get_info_wrap a.link.animate-arrow",function(e) {
e.preventDefault();
e.stopPropagation();
 $('html, body').animate({
        scrollTop: $(".hbspt-form").offset().top - 300
    }, 500);
  });


$('a[href="#Video"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  // Scroll to the #Video element
  $('html, body').animate({
    scrollTop: $('#Video').offset().top - 170 // Get the offset of the #Video element
  }, 1500); // 1500 is the duration of the scroll in milliseconds
});

// Faq Page back scroll js

$('a[href="#pagetop"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  $('html, body').animate({
    scrollTop: 0 // Scroll to the top of the page
  }, 1500); // 500 is the duration of the scroll in milliseconds
});

// End faq page back scroll js

// Faq page scroll top js 

$('a[href="#general"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#general');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 300); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#dealer"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#dealer');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 2000); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#orders"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#orders');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 1000); // 500 is the duration of the scroll in milliseconds
});  

$('a[href="#shipping"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#shipping');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 1500); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#returns"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#returns');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 2000); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#warranties"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#warranties');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 2000); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#prop65"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#prop65');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 2000); // 500 is the duration of the scroll in milliseconds
});

// End faq page scroll top js


// flooring page section id target js

$('a[href="#FlooringLines"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#FlooringLines');
  $('html, body').animate({
    scrollTop: target.offset().top - 200 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


$('a[href="#FlooringConsiderations"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#FlooringConsiderations');
  $('html, body').animate({
    scrollTop: target.offset().top - 200 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


$('a[href="#FlooringOptions"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#FlooringOptions');
  $('html, body').animate({
    scrollTop: target.offset().top - 200 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


$('a[href="#ConnectwithUs"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#ConnectwithUs');
  $('html, body').animate({
    scrollTop: target.offset().top - 200 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});

// End flooring page section id target js


// Training Space Design Inspiration page section id target js 

$('a[href="#Studio"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#Studio');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


$('a[href="#Group"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#Group');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


$('a[href="#Performance"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#Performance');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});

$('a[href="#Weight"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#Weight');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});

// End Training Space Design Inspiration page section id target js




// studio line storage page section id target js

$('a[href="#contact"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#contact');
  $('html, body').animate({
    scrollTop: target.offset().top - 150 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


// Facility Design  

$('a[href="#nextStep"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#nextStep');
  $('html, body').animate({
    scrollTop: target.offset().top - 100 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});


// outdoor fitness

$('a[href="#Connect"]').on('click', function(event) {
  event.preventDefault(); // Prevent default behavior
  var target = $('#Connect');
  $('html, body').animate({
    scrollTop: target.offset().top - 100 // Adjust the '- 200' as needed
  }, 500); // 500 is the duration of the scroll in milliseconds
});

// End studio line storage page section id target js
         $("section.product__info-container .shopify-block.shopify-app-block").on("click",function(e) {
e.preventDefault();
e.stopPropagation();
 $('html, body').animate({
        scrollTop: $(".custom-app-block.custom-customer-reviews").offset().top - 140
    }, 500);
});
         $(".Opage-listings.main_categories_listings a[aria-label='get_started']").on("click",function(e) {
e.preventDefault();
e.stopPropagation();
 $('html, body').animate({
        scrollTop: $(".hbspt-form").offset().top - 140
    }, 500);
});


// collection banner title js
function moveStrongTagsForMobile() {
  if (window.innerWidth <= 991) {
    // Move <strong> from <p> to mobile <p>
    var pStrong = document.querySelector('.read_less_description p strong');
    var mobileP = document.querySelector('.read_less_description.mobile-collection-title p');
    if (pStrong && mobileP && !mobileP.querySelector('strong')) {
      var cloneP = pStrong.cloneNode(true);
      mobileP.appendChild(cloneP);
    }

    // Move <strong> from <h2> to mobile <h2>
    var h2Strong = document.querySelector('.read_less_description h2 strong');
    var mobileH2 = document.querySelector('.read_less_description.mobile-collection-title h2');
    if (h2Strong && mobileH2 && !mobileH2.querySelector('strong')) {
      var cloneH2 = h2Strong.cloneNode(true);
      mobileH2.appendChild(cloneH2);
    }
  } else {
    // Optional: clear strong tags on desktop if needed
    var mobileP = document.querySelector('.read_less_description.mobile-collection-title p');
    var mobileH2 = document.querySelector('.read_less_description.mobile-collection-title h2');
    if (mobileP) mobileP.innerHTML = '';
    if (mobileH2) mobileH2.innerHTML = '';
  }
}

document.addEventListener('DOMContentLoaded', moveStrongTagsForMobile);
window.addEventListener('resize', moveStrongTagsForMobile);


function moveH3TextForMobileOnly() {
  const isMobile = window.innerWidth <= 991;

  const originalSection = document.querySelector('.collecton-des-sec h3');
  const mobileSection = document.querySelector('.collecton-des-sec.mobile-collection-title');

  if (originalSection && mobileSection) {
    const originalH3 = originalSection.querySelector('h3');
    const mobileH3 = mobileSection.querySelector('h3');

    if (isMobile && originalH3 && mobileH3 && !mobileH3.textContent.trim()) {
      mobileH3.textContent = originalH3.textContent;
    } else if (!isMobile && mobileH3) {
      mobileH3.textContent = '';
    }
  }
}

document.addEventListener('DOMContentLoaded', moveH3TextForMobileOnly);
window.addEventListener('resize', moveH3TextForMobileOnly);


function moveCollectionH3TextMobile() {
  const isMobile = window.innerWidth <= 991;

  const textWrapper = document.querySelector('.collection-hero__text-wrapper');
  const mobileBlock = document.querySelector('.collecton-des-sec.mobile-collection-title');

  if (textWrapper && mobileBlock) {
    const sourceH3 = textWrapper.querySelector('.collecton-des-sec h3');
    const targetH3 = mobileBlock.querySelector('h3');

    if (isMobile && sourceH3 && targetH3 && !targetH3.textContent.trim()) {
      targetH3.textContent = sourceH3.textContent;
    } else if (!isMobile && targetH3) {
      targetH3.textContent = '';
    }
  }
}

document.addEventListener('DOMContentLoaded', moveCollectionH3TextMobile);
window.addEventListener('resize', moveCollectionH3TextMobile);

document.addEventListener("DOMContentLoaded", function () {
   document.body.classList.remove("klaviyo-prevent-body-scrolling");
  // Remove body lock when Klaviyo form closes
  document.addEventListener("klaviyoForms", function (event) {
    if (event.detail.type === "formModalHidden") {
      document.body.classList.remove("klaviyo-prevent-body-scrolling");
    }
  });

  // Handle clicks outside the popup
  document.addEventListener("click", function (e) {
    const modalOverlay = document.querySelector('.needsclick[role="dialog"][aria-modal="true"]');
    if (!modalOverlay) return;

    const popupContent = modalOverlay.querySelector(".needsclick.kl-private-reset-css-Xuajs1");
    const closeButton = modalOverlay.querySelector(".klaviyo-close-form");

    // If clicked on overlay (outside popup content), close the popup
    if (modalOverlay && popupContent && !popupContent.contains(e.target) && modalOverlay.contains(e.target)) {
      if (closeButton) {
        closeButton.click(); // trigger Klaviyo's own close
      }
      document.body.classList.remove("klaviyo-prevent-body-scrolling");
    }
  });

  // Fallback for manual close button click
  document.addEventListener("click", function (e) {
    if (e.target.closest(".klaviyo-close-form")) {
      setTimeout(function () {
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
      }, 300);
    }
  });
});



